export const state = () => ({
	partners: [],
});

export const mutations = {
	setPartners(state: any, payload: any) {
		state.partners = payload;
	},
};

export const getters = {
	getPartners: (state: any) => state.partners,
};

export const actions = {
	getPartners(state: any) {
		if (state.state.partners.length) {
			return new Promise((resolve) => {
				resolve(state.state.partners);
			});
		}

		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/partners')
				.then((res) => {
					state.commit('setPartners', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
};
